import React, { Component } from 'react';
import { observer } from 'mobx-react';
import {
  ButtonToolbar,
  Button,
  Glyphicon,
} from 'react-bootstrap';


import Page from '../Page/Page';
// components
import LogList from '../../components/Log/LogList';
import Loading from '../../components/Shared/Loading';
// stores
import LogStore from '../../stores/LogStore';

import './Logs.css';

const Logs = observer(
class Logs extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: false }
  }

  render() {
    const { loading } = this.state;
    const logs = LogStore.logs;
    return (
      <Page
        title="Access logs"
        renderControlsInline={true}
        controls={this.renderControls()}>
        <div className="Logs-container">
          <div className="Logs-description">
            {this.renderDescription()}
          </div>
          { loading ?
            <div style={{"marginTop": "70px"}}>
              <Loading text="" size={10}/>
            </div> :
            <LogList logs={logs} />
          }
        </div>
      </Page>
    );
  }

  renderControls = () => {
    const { loading } = this.state;
    return (
      <ButtonToolbar>
        <Button bsStyle="primary" onClick={this.refresh} disabled={loading}>
          <Glyphicon glyph="refresh" /> Refresh
        </Button>
      </ButtonToolbar>
    );
  }

  renderDescription = () => {
    return (
      <p>
        Recent intercom activities including passcode accesses,
        invalid passcode attempts, and calls will be logged here.
      </p>
    )
  }

  refresh = () => {
    this.setState({ loading: true });
    setTimeout(() => {
      LogStore.refresh().then(() => this.setState({ loading: false }));
    }, 500);
  }
});

export default Logs;


// WEBPACK FOOTER //
// ./src/pages/Logs/Logs.js